import { RabbitIcon } from './RabbitIcon';

/**
 * author: Augustin Ursu
 * id 1D7338F8-4F44-43E3-906B-571178E63E49
 * name rabbit
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/rabbit.svg
 * tags
 * - Animal 
 * - Nature 
 */
export const BunnyIcon = RabbitIcon;
export default BunnyIcon